module.exports = __webpack_public_path__ + "978187ad3f894cffd7c7c522a8d3d2ae.png";